export default "__VITE_ASSET__CB2k0Myp__"